import { useStorefrontTheme, type ThemePreset } from "@/stores/storefrontThemeStore";
import { Palette } from "lucide-react";

const allThemes: { id: ThemePreset; label: string }[] = [
  { id: "classic", label: "Classic" },
  { id: "modern", label: "Modern" },
  { id: "minimal", label: "Minimal" },
  { id: "lite", label: "Lite" },
];
// Note: 'Lite' theme can be enabled/disabled via Admin → Storefront → Theme & Branding.

const StorefrontThemeSwitcher = () => {
  const { adminDefault, visitorToggleEnabled, visitorTheme, setVisitorTheme, disabledThemes } = useStorefrontTheme();
  if (!visitorToggleEnabled) return null;

  const enabledThemes = allThemes.filter(t => !(disabledThemes || []).includes(t.id));
  if (enabledThemes.length <= 1) return null;

  const active = visitorTheme || adminDefault;

  return (
    <div className="flex items-center gap-1.5 justify-center py-2 flex-wrap">
      <Palette className="w-3 h-3 text-muted-foreground" />
      {enabledThemes.map(t => (
        <button
          key={t.id}
          onClick={() => setVisitorTheme(t.id === adminDefault ? null : t.id)}
          className={`px-2.5 py-1 rounded-full text-[10px] font-semibold transition-all ${
            active === t.id
              ? "bg-primary text-primary-foreground"
              : "bg-muted/50 text-muted-foreground hover:bg-muted"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
};

export default StorefrontThemeSwitcher;
